export function initSamsaraDeliveries() {
    var $samsaraElement = $('[data-samsara]');
    var $viewAsAccount = $('#vaa');

    if ($samsaraElement.length) {
        $.ajax({
            url:
                '/samsara/ajaxGetDeliveries' +
                ($viewAsAccount.length ? '?au=' + $viewAsAccount.val() : ''),
            type: 'get',
            dataType: 'json',
            success: function (response) {
                if (response.banner) {
                    $samsaraElement.replaceWith(response.banner);
                }

                if (response.modal) {
                    $('#main').append(response.modal);
                }
            },
            error: function () {
                $samsaraElement.remove();
                console.error('Failed to get deliveries from Samsara.');
            },
        });
    }
}
